import React from "react";
import Game from "./components/game/game";

export const App = (): JSX.Element => {  
  return (
    <Game />
  );
}
